export default __webpack_public_path__ + "static/media/whileattach.22330853.svg";